import {action} from "typesafe-actions";
import {ProfileActionTypes} from './types';
import {Profile} from "../../models/Profile";

export const updateRequest = (payload: any) => action(ProfileActionTypes.UPDATE_REQUEST, payload);
export const fetchRequest = (id: string) => action(ProfileActionTypes.FETCH_REQUEST, id);
export const fetchSuccess = (data: Profile) => action(ProfileActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(ProfileActionTypes.FETCH_ERROR, [message]);
